import { atom } from "recoil";

const paymentDetailAtom = atom({

    key:"paymentDetail",
    default: {}

});

export default paymentDetailAtom;